import "isomorphic-fetch";
import { EventEmitter } from "events";

export class RestClient extends EventEmitter {
	constructor(options) {
		super();
		this._options = options;
	}

	exec_get(url, callback) {
		this._fetch("GET", url, undefined, null, callback);
	}

	exec_post(url, body, callback) {
		this._fetch("POST", url, body, "application/json", callback);
	}

	exec_multipartPost(url, body, callback) {
		this._fetch("POST", url, body, "multipart", callback);
	}

	exec_put(url, body, callback) {
		this._fetch("PUT", url, body, null, callback);
	}

	exec_delete(url, callback) {
		this._fetch("DELETE", url, undefined, null, callback);
	}

	// -- todo: use promises instead of callback
	_fetch(method, req, body, contentType, callback) {
		const url = typeof req === "object" ? req.url : req;
		const timeout = typeof req === "object" ? req.timeout || 30000 : 30000;
		const controller = new AbortController();
		const timeoutId = setTimeout(() => controller.abort(), timeout);
		const checkStatus = function (response) {
			if (!response.ok) {
				return Promise.reject(Object.assign({}, { response }));
			}
			return Promise.resolve(response);
		};

		const headers = {
			"Content-Type": "application/json;charset=UTF-8"
		};

		if (contentType === "multipart") delete headers["Content-Type"];

		const request = new Request(url, {
			method: method,
			credentials: "include",
			headers: new Headers(headers),
			body: body,
			redirect: "follow",
			signal: controller.signal
		});

		fetch(request)
			.then((response) => {
				clearTimeout(timeoutId);
				return checkStatus(response);
			})
			.then((response) => response.json().then((result) => ({ result, response })))
			.then(({ result, response }) => {
				// Emit the number of bytes received
				const contentLength = response.headers.get("Content-Length");
				if (contentLength) {
					this.emit("dataReceived", parseInt(contentLength, 10));
				}
				if (callback) {
					callback(null, result);
				}
			})
			.catch((err) => {
				clearTimeout(timeoutId);
				if (callback) {
					callback(err, null);
				}
			});
	}
}
